import t,{keyframes as a}from"styled-components";import{theme as e}from"../../../../theme.js";const n=a`
  0% {
    transform: rotate(0);
  }
  20% {
    transform: rotate(-16deg);
  }
  40% {
    transform: rotate(0deg);
  }
  60% {
    transform: rotate(16deg);
  }
  80% {
    transform: rotate(-8deg);
  }
  100% {
    transform: rotate(0);
  }
`,i=t.div`
  .label {
    font-size: 16px;
    line-height: 24px;
    color: ${e.colors.gray[900]};
  }
  .mobile {
    display: none;
  }
  .desktop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      display: flex;
      gap: ${e.spacing*6}px;
      align-items: center;
    }
  }
  @media screen and (max-width: ${e.breakpoints.lg}) {
    .desktop {
      display: none;
    }
    .mobile {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: ${e.spacing*4}px;
      > div {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
        > div {
          display: flex;
          gap: ${e.spacing*6}px;
          align-items: center;
        }
      }
    }
  }
`,o=t.button`
  display: flex;
  gap: ${e.spacing}px;
  align-items: center;
  border: none;
  padding: 0;
  background-color: unset;
  cursor: pointer;
  > svg {
    width: 24px;
    height: 24px;
    > g,
    path {
      fill: ${e.colors.gray[900]};
    }
    &.red {
      > g,
      path {
        fill: ${e.colors.additional.magenta[300]};
      }
    }
    &.green {
      > g,
      path {
        fill: ${e.colors.additional.green[300]};
      }
    }
  }
  &:hover {
    > svg {
      animation: ${n} .5s .5s ease-in-out;
    }
  }
`;export{o as Button,i as Container};
